/**
 *
 * CourseDetailMobile
 *
 */

import React, { memo, useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import { createStructuredSelector } from 'reselect';
import { compose } from 'redux';
import { useParams } from 'react-router-dom';

// styles
import './style.scss';

import { useInjectSaga } from 'utils/injectSaga';
import { useInjectReducer } from 'utils/injectReducer';
import reducer from './reducer';
import saga from './saga';

import { flushState, loadCourse, updateCourse } from './actions';
import {
  makeSelectLoading,
  makeSelectError,
  makeSelectCourseDetail,
} from './selectors';

// antd component
import { Layout } from 'antd';
const { Content } = Layout;

// assets
import { ArrowLeftOutlined } from '@ant-design/icons';

// components
import CourseCard from 'mobile/components/CourseCard';
import ExcusedStudents from 'mobile/components/ExcusedStudents';
// containers
import AttendanceControl from 'mobile/containers/AttendanceControl';

// global user
import { withUser } from 'engine/Contexts/User.context';

export function CourseDetailMobile({
  // main data
  courseDetail,
  // states
  user,
  history,
  error,
  loading,
  // actions
  loadCourse,
  updateCourse,
  flushState,
}) {
  useInjectReducer({ key: 'courseDetailMobile', reducer });
  useInjectSaga({ key: 'courseDetailMobile', saga });

  const { id: initId } = useParams();

  const [currentCourse, setCurrentCourse] = useState(courseDetail);

  const onDate = history.location?.state?.onDate;
  const goBack = history.location?.state?.goBack;
  const goBackTitle = history.location?.state?.goBackTitle;

  // Get Course Data
  useEffect(() => {
    initId && loadCourse(initId);
  }, [initId]);

  useEffect(() => {
    courseDetail && setCurrentCourse(courseDetail);
  }, [courseDetail]);

  // Clearing the state after unmounting a component
  // - work like ComponentDidUpdate
  useEffect(() => {
    return () => {
      // Anything in here is fired on component unmount.
      flushState();
    };
  }, []);

  // render function
  return (
    <Layout className="main-full-content">
      <Helmet>
        <title>Cours</title>
        <meta name="description" content="Description of Cours" />
      </Helmet>
      <Content className="main-content-container course-detail">
        <div className="course-detail__header">
          <div
            className="go-back"
            onClick={() => history.push(goBack ? goBack : `/сours`)}
          >
            <ArrowLeftOutlined /> {goBackTitle ? goBackTitle : 'Cours'}
          </div>
        </div>
        <div className="course-detail__main">
          <CourseCard data={currentCourse} />
          <ExcusedStudents
            course={currentCourse}
            loading={loading}
            dataSource={currentCourse?.students || []}
            onDate={onDate}
          >
            <AttendanceControl
              mode="course"
              course={currentCourse}
              onDate={onDate}
              updateCourse={courseData => setCurrentCourse(courseData)}
            />
          </ExcusedStudents>
        </div>
      </Content>
    </Layout>
  );
}

CourseDetailMobile.propTypes = {
  dispatch: PropTypes.func.isRequired,
  flushState: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

const mapStateToProps = createStructuredSelector({
  loading: makeSelectLoading(),
  error: makeSelectError(),
  courseDetail: makeSelectCourseDetail(),
});

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
    flushState: () => dispatch(flushState()),
    loadCourse: id => dispatch(loadCourse(id)),
    updateCourse: itemData => dispatch(updateCourse(itemData)),
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default compose(
  withConnect,
  memo,
  withUser,
)(CourseDetailMobile);
